import { combineReducers } from '@reduxjs/toolkit';

import auth from './auth';
import cart from './cart';
import home from './home';
import order from './order';

const rootReducer = combineReducers({
  cart,
  auth,
  order,
  home,
});

export default rootReducer;
